import * as React from 'react';
import * as Modal from "react-modal";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { useDispatch, useSelector } from "react-redux";
import { ModalProps } from '../types';
import { DOCUMENT_STATUS } from '../const';

export const HistoryModal = (props: ModalProps) => {
    const { isOpen } = props;
    const dispatch = useDispatch();

    const [state ] = useSelector((state: any) => [
        state.SignGridComponentReducer
    ]);

    const { statusHistory } = state;

    const handleClose = () => {
        dispatch({ type: 'TOGGLE_HISTORY_MODAL', payload: false});
    };

    const dateFormatter = (cell, row) => {
        const sourceDate = new Date(cell);
    
        if (sourceDate instanceof Date) {
            const date = new Date(Date.UTC(sourceDate.getFullYear(), sourceDate.getMonth(), sourceDate.getDate(), sourceDate.getHours(), sourceDate.getMinutes(), sourceDate.getSeconds()));
            return `${('0' + date.getDate()).slice(-2)}.${('0' + (date.getMonth() + 1)).slice(-2)}.${date.getFullYear()} ${('0' + (date.getHours())).slice(-2)}:${('0' + (date.getMinutes())).slice(-2)}`;
        }

        return null
    }

    const statusFormatter = (cell) => DOCUMENT_STATUS[cell];

    const config ={
        height: '310px',
        options: {
            noDataText: 'У вас пока нет историй изменений статусов в заявке ',
        }
    }

    const html = (cell, row) =>{
        return <div style={{whiteSpace:"pre-line"}} dangerouslySetInnerHTML={{__html:cell}}></div>
    }

    return (
        // @ts-ignore
        <Modal 
            isOpen={isOpen}
            className="react-bs-insert-modal modal-dialog"
            contentLabel="Modal"
            ariaHideApp={false}
        >
            <div className="modal-content react-bs-table-insert-modal">
                <div className="modal-header">
                    <button type="button" className="close" onClick={handleClose}>
                        <span aria-hidden="true">×</span>
                    </button>
                    <h4 className='modal-title'>История</h4>
                </div>
                <div className='modal-body'>
                <BootstrapTable {...config} data={statusHistory} bodyContainerClass="react-bs-container-body_v1">
                        <TableHeaderColumn dataField='id' isKey={true} hidden></TableHeaderColumn>
                        <TableHeaderColumn dataField='createTime' dataFormat={dateFormatter}>Дата создания</TableHeaderColumn>
                        <TableHeaderColumn dataField='status' dataFormat={statusFormatter}>Статус</TableHeaderColumn>
                        <TableHeaderColumn dataField='value' dataFormat={html}>Уведомление</TableHeaderColumn>
                </BootstrapTable>
                </div>
                <div className="modal-footer">
                    <button type='button' className="btn btn-default" onClick={handleClose}>Закрыть</button>
                </div>
            </div>
        </Modal>
    )
};
